<div fxLayout="column" style="background-color: white; height: 100vh;">

  <div fxLayout="row" fxLayoutAlign="center center">

    <!-- login form section -->
    <div fxLayoutAlign="center center center" [ngStyle.lt-md]="{width: '100%'}" [ngStyle.gt-md]="{width: '25%'}"
         class="loginForm" [style.height.px]="imageHeight">

      <div fxLayout="column" fxLayoutAlign="center center">

        <div fxLayout="row" fxLayoutAlign="center center" style="margin-bottom:50px;">
          <img src="../../../assets/images/econsent_logo_final.png" style="height: 150px; width: auto;" alt="">
        </div>


        <div fxLayout="row" style="padding:16px;">
          <div fxLayout="column">

            <div fxLayout="row" class="welcomeMessage">Καλώς ορίσατε στο σύστημα διαχείρισης δηλώσεων και συναινέσεων
            </div>

            <div fxLayout="row">

              <div fxLayout="column" fxFlex="grow">

                <form [formGroup]="loginFormGroup" (keydown)="keyDownFunction($event)">
                  <div fxLayout="row">
                    <mat-form-field style="width:100%;">
                      <label>
                        <input matInput placeholder="Αναγνωριστικό χρήστη"
                               formControlName="email">
                      </label>
                      <mat-error
                        *ngIf="loginFormGroup.get('email').touched && loginFormGroup.get('email').invalid">
                        {{ loginFormGroup.get('email').errors.required ? 'Υποχρεωτικό πεδίο.' : 'Λάθος τύπος email.' }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="row">
                    <mat-form-field style="width: 100%; margin-top: 10px;">
                      <label>
                        <input matInput [type]="hide ? 'password' : 'text'"
                               placeholder="Κωδικός χρήστη" formControlName="password">
                      </label>
                      <mat-icon matSuffix
                                (click)="hide = !hide">{{ hide ? 'visibility_off' : 'visibility' }}
                      </mat-icon>
                      <mat-error
                        *ngIf="loginFormGroup.get('password').touched && loginFormGroup.get('password').invalid">
                        Υποχρεωτικό πεδίο.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </form>
              </div>

            </div>

            <div *ngIf="productSchoolId === 2" fxLayout="row" fxFlex="grow" fxLayoutAlign="center center"
                 style="margin-bottom: 10px;">
              <button mat-flat-button (click)="navigateToRegistration()"><u>Εγγραφή γόνέα</u></button>
            </div>


            <div fxLayout="row" fxFlex="grow" fxLayoutAlign="center center">
              <button mat-flat-button id="buttonLogin" class="login-btn" (click)="onLogin()"
                      [class.spinner]="loading" [disabled]="loading">
                <span id="buttonText">Είσοδος</span>
              </button>
            </div>
          </div>
        </div>

        <!--Privacy Notice-->
        <div fxLayout="row" fxLayoutAlign="center center" style="height:10%; margin-top:50px; bottom:0"
             [style.width.%]="'100'" ngStyle.lt-md="padding-left:15px; padding-right:15px;">
          <a style="cursor: pointer !important; color: var(--primary); text-decoration: underline;"
             href="" target="_blank">Privacy Notice</a>
        </div>
        <!--      -->
      </div>


    </div>
    <!-- end login form section -->
  </div>

</div>
